import React from 'react';
import '../components/css/TermsOfServiceModal.css';

const TermsOfServiceModal = ({ show, handleClose }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="close" aria-label="Close terms" onClick={handleClose}>&times;</button>
        <h2>Terms of Service</h2>

        <p><strong>Last updated:</strong> July 6, 2025</p>

        <h2>1. Introduction</h2>
        <p>
          Welcome to Cosmos-Station / Create Nodes. These Terms of Service ("Terms") govern your access to and use of our website (the “Service”) operated by Create Nodes Ltd. ("we", "us", "our"). By accessing or using our Service, you agree to be bound by these Terms and to our Privacy Policy. These Terms apply to all users of our Service.
        </p>
        <p>
          Create Nodes provides validator hosting, blockchain node setup, and staking-related infrastructure for users of the Terra Classic (LUNC) blockchain. We do <strong>not</strong> provide financial or investment advice, and we are <strong>not</strong> a cryptocurrency exchange. All decisions you make regarding digital assets are solely your responsibility.
        </p>

        <h2>2. Use of the Service</h2>
        <h3>A. Eligibility</h3>
        <p>You must be 18 years or older to use our Service. By using the Service, you affirm that you are of legal age and eligible to enter into this agreement.</p>

        <h3>B. Account Conduct</h3>
        <p>You agree to use the Service lawfully and respectfully. You must not:</p>
        <ul>
          <li>Violate any local, national, or international law.</li>
          <li>Attempt to interfere with the integrity or security of the platform.</li>
          <li>Impersonate others or provide false information.</li>
          <li>Upload viruses or malicious code.</li>
          <li>Post unauthorized promotions or spam.</li>
          <li>Collect user information without consent.</li>
        </ul>

        <h3>C. Changes to the Service</h3>
        <p>We reserve the right to change or discontinue any part of the Service at any time, with or without notice. You agree that we are not liable for any changes, interruptions, or discontinuations.</p>

        <h2>3. Node Services</h2>
        <p>To use our validator or node setup services, you may need to:</p>
        <ul>
          <li>Provide a valid Terra Classic wallet address and seed phrases, these are a one time use to connect to the validator and are NOT kept.</li>
          <li>Submit validator metadata (e.g., moniker, website, commission rate).</li>
          <li>Pay for server provisioning and hosting if applicable.</li>
        </ul>
        <p>We may automate the creation of validator nodes using your provided credentials and seed phrases, which we treat securely and do not store after initial setup.</p>

        <h2>4. Payments and Fees</h2>
        <h3>A. Pricing</h3>
        <p>Our services may involve one-time setup fees or monthly hosting costs. All prices are listed in GBP or USD and may change at our discretion.</p>
        <p>By using our Service, you authorize us to charge your payment method for the agreed fees. You are responsible for ensuring that your payment information is accurate and up-to-date.</p>
        <p>Payments are due on the same calendar day each month as the validator's activation date. For example, if activated on July 1st, payments will be due on the 1st of each subsequent month. Failure to make payment on time may result in the validator being deactivated. </p>


        <h3>B. Refunds</h3>
        <p>Due to the automated and digital nature of node setup, <strong>all payments are final and non-refundable</strong> once services are rendered.</p>

        <h3>C. Failed Payments</h3>
        <p>Failure to maintain payment may result in suspension or termination of validator node hosting.</p>

        <h2>5. Data and Privacy</h2>
        <p>Your use of the Service is subject to our <a href="/privacy-policy">Privacy Policy</a>. We take data protection seriously and use reasonable efforts to secure your personal and blockchain-related information.</p>

        <h2>6. Intellectual Property</h2>
        <p>All materials on the Cosmos-Station website—including text, code, graphics, logos, and branding—are the property of Create Nodes Ltd. or its licensors. You may not copy, reuse, or redistribute any of our content without written permission.</p>

        <h2>7. Limitation of Liability</h2>
        <p>We do not guarantee uptime or success of validator performance. You use the Service at your own risk. We are not liable for:</p>
        <ul>
          <li>Lost staking rewards</li>
          <li>Downtime due to blockchain events</li>
          <li>Bugs or API failures from third-party blockchain services</li>
        </ul>
        <p>In no event shall our liability exceed the total amount you paid for the Service.</p>

        <h2>8. Termination</h2>
        <p>We reserve the right to suspend or terminate your access to the Service at our sole discretion if you violate these Terms or pose a threat to our infrastructure or users.</p>

        <h2>9. Changes to Terms</h2>
        <p>We may update these Terms at any time. Continued use of the Service after changes constitutes acceptance of the revised Terms.</p>

        <h2>10. Contact</h2>
        <p>If you have any questions, please contact us:</p>
        <ul>
          <li>Email: <a href="mailto:LunaClassicStation@gmail.com">LunaClassicStation@gmail.com</a></li>
          <li>Company: Create Nodes Ltd., United Kingdom</li>
        </ul>
      </div>
    </div>
  );
};

export default TermsOfServiceModal;
